export default "__VITE_ASSET__0a16ed36__"